// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#trial-break-progress-bar-wrapper {
  display: none;
  position: absolute;
  bottom: 0.25rem;
  left: 50%;
  transform: translateX(-50%);
  width: 2.25rem;
  height: 0.75rem;
  border: 1px solid black;
  background-color: #eee;
  z-index: 1000009;
}

#trial-break-progress {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  background-color: green;
  z-index: 1000009;
}
`, "",{"version":3,"sources":["webpack://./components/css/takeABreak.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["#trial-break-progress-bar-wrapper {\n  display: none;\n  position: absolute;\n  bottom: 0.25rem;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2.25rem;\n  height: 0.75rem;\n  border: 1px solid black;\n  background-color: #eee;\n  z-index: 1000009;\n}\n\n#trial-break-progress {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  background-color: green;\n  z-index: 1000009;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
